var exports = {
  "k": "xe564cbfb--40190f--container",
  "D": "xe564cbfb--40190f--title",
};

module.exports = exports;
